// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"b4a626b2","146":"22f7263a","365":"17f286ce","556":"b50df953","746":"0d733ec2"}[chunkId] + ".chunk.css";
};